export default {
  hi_im_neela: 'Привіт, я Ніла,',
  english: 'English',
  german: 'Deutsch',
  french: 'Français',
  dutch: 'Nederlands',
  swedish: 'Sweden',
  ukrainian: 'Українці',
  turkish: 'Türkçe',
  russian: 'Русский',
  spanish: 'Español',
  italian: 'Italiano',
  arabic: 'عربي',
  polish: 'Polska',
  aareons_virtual: 'віртуальний помічник Аарона.',
  media: 'Медіа',
  media_link: 'https://neela.aareon.de/media',
  contact: 'Контакт',
  contact_link: 'https://neela.aareon.de/contact',
  privacy: 'Захист даних',
  privacy_link: 'https://www.aareon.de/sixcms/detail.php/46076',
  terms_of_use: 'Умови використання',
  terms_of_use_link:
    'https://www.aareon.com/Allgemeine_Informationen/Nutzungsbedingungen.2366.html',
  legal_notice: 'Відбиток',
  legal_notice_link: 'https://neela.aareon.de/legal',
  show_system_messages: 'Показати системні повідомлення',
  dont_show_system_messages: 'Приховати системні повідомлення',
  logged_in: 'Орендар пройшов аутентифікацію',
  logged_out: 'Анонімний користувач',
  button_switch_locale: 'Змінити мову',
  button_tooltip_activate_voice_recognition: 'Активувати розпізнавання мови',
  date_input: 'Виберіть дату',
  choose_two_dates: 'Будь ласка, оберіть дві дати',
  date_range: 'Діапазон дат',
  from: 'від',
  to: 'до',
  avatar: 'Аватар',
  exit: 'Кінець',
  new: 'Новий',
  back: 'Назад',
  suggestions: 'Пропозиції',
  senton: 'надіслано',
  message_placeholder: 'Введіть повідомлення тут',
  comment_placeholder: 'Введіть коментар тут',
  file_max_upload_text: 'Можна завантажити максимум 20 файлів',
  message_button_label: 'Надіслати',
  please_confirm: 'Будь ласка, підтвердіть',
  no: 'Ні',
  yes: 'Так',
  modal_delete_session: 'Видалити сесію',
  modal_delete_session_notification:
    'Коли Ви закриєте вікно, Ваша сесія також буде видалена.<br>Ви згодні?',
  template_contact_time: "Коли ми можемо з вами зв'язатися?",
  template_pause:
    'У вашому засіданні оголошено перерву. Один з наших співробітників служби підтримки розгляне Ваш запит найближчим часом.',
  template_continue_after_pause:
    'Ваше засідання відновлено. Тепер ви можете продовжити листування з нашим чат-ботом.',
  button_apply: 'Прийняти',
  button_cancel: 'Скасувати',
  none: 'Немає',
  book_appointment: 'Записатися на прийом',
  address_input: 'Введіть адресу',
  data_processing: 'Обробка даних',
  privacy_policy: 'політику конфіденційності',
  data_processing_notification_before_link:
    'Для того, щоб ви могли користуватися даним сервісом чату, необхідно, щоб ви прийняли',
  data_processing_notification_after_link: '.',
  button_accept: 'Прийняти',
  select_date: 'Виберіть дату',
  rate_conversation: 'Як би Ви оцінили цю розмову?',
  new_ticket_question: 'Чи можу я ще чимось допомогти?',
  thank_you:
    'Дякуємо за вашу підтримку. Ваші відгуки допомагають мені завжди вдосконалюватися.',
  goodbye: 'До зустрічі',
  start_new: 'Почніть нову розмову',
  operator_entered_the_chat: 'Співробітник приєднався до чату.',
  operator_left_the_chat: 'Співробітник припинив розмову.',
  bg_image: process.env.VUE_APP_DE_BG,
  expand_quickreplies: 'Більше',
  collapse_quickreplies: 'Менше',
  login: 'Увійдіть',
  logout: 'Вийдіть',
  close: 'Закрити',
  upload_file: 'Помістіть файл для завантаження тут',
  upload_file_or: 'або',
  Upload_file_select: 'додайте файл',
  upload_file_text: 'Файл для завантаження',
  show_attachments: 'Показати вкладення',
  hide_attachments: 'Приховати вкладення',
  maximize: 'Максимізувати',
  minimize: 'Мінімізувати',
  feedback_helpful: 'Ця відповідь допомогла мені',
  feedback_not_helpful: 'Ця відповідь мені не допомогла',
  chatProtocol: 'Протокол чату',
  showMore: 'Показати більше',
  showLess: 'Показати менше',
  uploadTooltip: 'Завантажити файл',
  uploadFilesTooltip: 'Завантажити файли',
  pdfDownloadTooltip: 'Завантажити Розмова',
  feedbackDescription: "Эворотній зв'язок",
  feedbackSubtitle: {
    description:
      'Тут ви можете надсилати нам загальні побажання, пропозиції та запити.',
    note: 'Зверніть увагу, що ми не можемо на них відповісти.',
    hint:
      'Всі інші проблеми, які стосуються саме вашої оренди або пошуку квартири, ви можете описати нам в чаті.'
  },

  feedbackPlaceholder: 'Введіть своє повідомлення тут...',
  sendFeedback: 'Надіслати',
  giveFeedback: "Эворотній зв'язок",
  feedbackSubmittedSuccessfully: 'Ваш відгук було успішно відправлено.',
  thanks: 'Дякую'
}
